import { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';

import { Link } from 'react-router-dom';
import {
  Grid, useMediaQuery, makeStyles, InputLabel, Select, MenuItem, Button, TextField
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';

import { useTheme } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocalization, useTranslation } from '../../LocalizationProvider';
import StartPage from '../../StartPage';
import { api_call, console_log, empty, getToken, get_utc_timestamp_ms, setToken, validateEmail } from '../../helpers/untils';
import { GPS_ID_PLACEHOLDER, ICCID_PLACEHOLDER, IMAGE_CACHE_VERSION, RECAPTCHA_ENABLED } from '../../config/constant';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import { getSettingPersist, setSettingPersist, sleep } from '../../helpers/misc';
import CaptchaBox from '../CaptchaBox';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    textAlign: 'center',
    color: theme.palette.primary.main,
  },
  imgSmall: {
    width: '50px',
    height: '40px',
    marginLeft: '5px',
    marginTop: '5px',
    borderRadius: '4px',
    cursor: 'pointer',
    objectFit: 'cover',
    objectPosition: 'center'
  },
  customSnakebar: {
    position: 'absolute',
    top: '140px'
  },
  mobileInstallerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center'
  }
}));

const InstallerLoginFormTest = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const t = useTranslation();

  const { languages, language, setLanguage } = useLocalization();
  const languageList = Object.entries(languages).map((values) => ({ code: values[0], name: values[1].name }));
  const [errorFields, setErrorFields] = useState([]);

  const formDefaultData = {
    iccid: "", // "000000000"
    uniqueId: "", // "MT09G00000"
    phone_email: "",
    mobile_installer: "0",
    iccid_prefix: ""
  }
  const [formData, setFormData] = useState(formDefaultData);
  const [isOpen, setIsOpen] = useState('');
  const [currentImage, setCurrentImage] = useState('');

  const [submitting, setSubmitting] = useState(false);

  const iccidImage = `/images/iccid/large1.jpg?v=${IMAGE_CACHE_VERSION}`
  const gpsidImage = `/images/gpsid/large1.jpg?v=${IMAGE_CACHE_VERSION}`

  const defaultPageData = {
    iccidPrefixList: []
  }

  const [pageData, setPageData] = useState(defaultPageData)
  const [iccidPrefixList, setIccidPrefixList] = useState([])
  const getPageData = async () => {
    let url = `/api/get-iccid-prefix-list`
    let response = await api_call(url, {
      method: 'GET',
    });

    if (response.ok) {
      const apiRes = await response.json()
      setPageData(apiRes)
      setIccidPrefixList(getIccidPrefixListOptions(apiRes['iccidPrefixList']))
      const lastIccidPrefix = apiRes['iccidPrefixList'][0]
      setFormData({ ...formData, iccid_prefix: lastIccidPrefix?.iccid_prefix ?? "" })
    } else {
      return false
    }
  }
  useEffect(() => {
    getPageData()
  }, [])

  const getIccidPrefixListOptions = (iccid_prefix_ist) => {
    const iccidPrefixListOptions = []
    for (let i in iccid_prefix_ist) {
      iccidPrefixListOptions.push({ id: iccid_prefix_ist[i]['iccid_prefix'], name: iccid_prefix_ist[i]['iccid_prefix'] })
    }
    console.log(`iccidPrefixListOptions:::`, iccidPrefixListOptions)
    return iccidPrefixListOptions;
  }

  ///////////// start recaptcha part //////////////////////////////////////////////////////////////////////////
  const captchaKey = 'captcha_installer_login'
  const [recaptcha, setRecaptcha] = useState(RECAPTCHA_ENABLED === "false" ? "xxxxxxxxxxxxxxxxx" : "");
  const [captchaTimestamp, setCaptchaTimestamp] = useState(get_utc_timestamp_ms());
  const updateCaptchaSettingEnabled = (value) => {
    const oldValue = getSettingPersist(captchaKey)
    if (true || oldValue !== value) { // refresh every attempt
      setSettingPersist(captchaKey, value)
      setCaptchaTimestamp(get_utc_timestamp_ms())
    }
  }
  ///////////// end recaptcha part //////////////////////////////////////////////////////////////////////////

  const handleSubmit = async (event) => {
    event.preventDefault();
    const rand = () => Math.floor((1 + Math.random()) * 0x100000000).toString(16).substring(1);
    const session = "installer-" + rand();
    var data = { ...formData, session: session };
    if (formData['uniqueId'].length < 5) {
      setToast("Invalid GPS ID")
      setSnackbarOpen(true)
      setErrorFields([...errorFields, 'uniqueId'])
      return false
    }
    if (empty(formData['iccid_prefix'])) {
      setToast("Please choose ICCID prefix")
      setSnackbarOpen(true)
      setErrorFields([...errorFields, 'iccid_prefix'])
      return false
    }
    if (formData['iccid'].length < 5) {
      setToast("Invalid ICCID")
      setSnackbarOpen(true);
      setErrorFields([...errorFields, 'iccid'])
      return false
    }
    if (!validateEmail(formData['phone_email'])) {
      setToast("Invalid email address")
      setSnackbarOpen(true);
      setErrorFields([...errorFields, 'phone_email'])
      return false
    }

    setSubmitting(true)
    const response = await api_call('/api/check-installer-device', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const sessionData = await response.json();
      console_log("sessionData:::::::", sessionData);
      if (sessionData['error']) {
        setToast(sessionData['error'])
        setSnackbarOpen(true);
        setSubmitting(false)
        return false
      }
    }
    await processSubmit(data)
  }

  const processSubmit = async (data) => {
    setToast("Please wait, Process can take up to 20 minutes.")
    setSnackbarOpen(true)
    setSubmitting(true)

    setErrorFields([])

    const response = await api_call('/api/installer-auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const sessionData = await response.json();
      console_log("sessionData:::::::", sessionData);
      if (sessionData['error']) {
        setToast(sessionData['error'])
        setSnackbarOpen(true);
        setSubmitting(false)
        updateCaptchaSettingEnabled(true)
      } else {
        if (sessionData['status'] === 'waiting') {
          await scanCheckGpsIccidMatched({ ...data })
          if (sessionData['message']) {
            setToast(sessionData['message'])
            setSnackbarOpen(true);
          }
        } else {
          redirectToMainPage(sessionData)
          updateCaptchaSettingEnabled(false)
          return true
        }
      }
    } else {
      const errorMsg = response?.message ?? (response?.error ?? "Internal server error")
      setToast(errorMsg)
      const error_fields = response?.errorFields
      if (error_fields) {
        setErrorFields([...errorFields, ...error_fields])
      }
      setSnackbarOpen(true)
      setSubmitting(false)
      updateCaptchaSettingEnabled(true)
    }

    setTimeout(() => {
      setSnackbarOpen(false)
    }, 3000)
  }

  const scanCheckGpsIccidMatched = async (data) => { // check every 30s for 10 minutes
    let i = 0;
    let cnt = 18; //18
    for (i = 0; i < cnt; i++) {
      let is_final = 0
      if (i === cnt - 1) {
        is_final = 1
      }
      const rslt = await checkGpsIccidMatched(data, is_final);
      if (rslt) { // if true, don't need to scan again
        return false
      }
      await sleep(30 * 1000)  //30 * 1000
    }
  }

  const checkGpsIccidMatched = async (data, is_final) => { // check every 30s for 10 minutes
    const response = await api_call('/api/check-gpsid-iccid-matched', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...data, is_final: is_final }),
    });
    if (response.ok) {
      const sessionData = await response.json();
      console_log("sessionData:::::::", sessionData);
      if (sessionData['error']) {
        if (is_final === 1) {
          setToast(sessionData['error'])
          setSnackbarOpen(true);
          setSubmitting(false)
          updateCaptchaSettingEnabled(true)
          return true
        } else {
          return false // scan again
        }
      } else {
        redirectToMainPage(sessionData)
        updateCaptchaSettingEnabled(false)
        return true
      }
    } else {
      if (is_final === 1) {
        const errorMsg = response?.message ?? (response?.error ?? "Internal server error")
        setToast(errorMsg)
        const error_fields = response?.errorFields
        if (error_fields) {
          setErrorFields([...errorFields, ...error_fields])
        }
        setSnackbarOpen(true)
        setSubmitting(false)
        return true
      } else {
        return false // scan again
      }
    }
  }

  const sendInstallerAuthEmail = async (sessionData) => {
    const response = await api_call('/api/send-installer-auth-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...sessionData }),
    });
    // if (response.ok) {
    //   const sessionData = await response.json();
    // }
  }

  const redirectToMainPage = async (sessionData) => {
    console_log("sessionData::::", sessionData)
    //return false;
    await sendInstallerAuthEmail(sessionData)

    setToken(sessionData['token'])
    history.push('/installer-main') //window.location.href = '/installer-main';
  }

  const handleSpecialKey = (e) => {
    if (e.keyCode === 13 && formData['iccid'] && formData['uniqueId'] && recaptcha) {
      handleSubmit(e);
    }
  };
  const onChange = (value) => {
    console.log(value);
    setRecaptcha(value);
  }

  const applyLogout = async () => {
    const m_token = getToken();
    if (m_token) {
      const url = `/api/installer-auth`
      const response = await api_call(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      setToken("")
    }
  }

  useEffect(() => {
    applyLogout()
  }, []);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toast, setToast] = useState("");
  return (
    <>
      <StartPage>
        <div className='custom-snakebar'>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={10 * 60 * 1000}
            message={toast}
          >
          </Snackbar>
        </div>

        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={2}>
            {useMediaQuery(theme.breakpoints.down('md'))
              && (
                <Grid item className={classes.logoContainer}>
                  <Link to="/">
                    <img height="85" width="240" src="/logo.png" alt="Moovetrax" />
                  </Link>
                </Grid>
              )}

            <Grid item style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
              <TextField
                required
                fullWidth
                error={errorFields.includes('uniqueId')}
                label={`GPS ID`}
                name="uniqueId"
                value={formData['uniqueId']}
                type="text"
                autoFocus={true}
                onChange={(e) => {
                  setFormData({ ...formData, uniqueId: e.target.value });
                  setErrorFields([errorFields.filter((i) => i !== 'uniqueId')])
                }}
                onKeyUp={handleSpecialKey}
                variant="filled"
                inputProps={{ style: { textTransform: "uppercase" }, maxLength: "12" }}
                placeholder={GPS_ID_PLACEHOLDER}
                disabled={submitting}
              />
              <img className={classes.imgSmall}
                src={`/images/gpsid/small1.jpg?v=${IMAGE_CACHE_VERSION}`}
                alt="How to get GPSID"
                title="How to get GPSID"
                onClick={() => {
                  setCurrentImage(gpsidImage)
                  setIsOpen(true)
                }}
              />
            </Grid>
            <Grid item style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
              <FormControl fullWidth variant="filled" style={{ marginRight: '4px' }}>
                <InputLabel>{'ICCID Prefix'}</InputLabel>
                <Select
                  value={formData.iccid_prefix}
                  onChange={(event) => {
                    setFormData({ ...formData, iccid_prefix: event.target.value });
                    setErrorFields([errorFields.filter((i) => i !== 'iccid_prefix')])
                  }}
                  error={errorFields.includes('iccid_prefix')}
                >
                  {iccidPrefixList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                required
                fullWidth
                error={errorFields.includes('iccid')}
                label={`ICCID`}
                name="iccid"
                value={formData['iccid']}
                autoComplete="iccid"
                onChange={(e) => {
                  setFormData({ ...formData, iccid: e.target.value.substring(0, 9) });
                  setErrorFields([errorFields.filter((i) => i !== 'iccid')])
                }}
                onKeyUp={handleSpecialKey}
                //helperText={failed && 'The combination you entered is not found'}
                variant="filled"
                inputProps={{ style: { textTransform: "none" }, type: "number", min: 0 }}
                placeholder={ICCID_PLACEHOLDER}
                disabled={submitting}
              />
              <img className={classes.imgSmall}
                src={`/images/iccid/small1.jpg?v=${IMAGE_CACHE_VERSION}`}
                alt="How to get ICCID"
                title="How to get ICCID"
                onClick={() => {
                  setCurrentImage(iccidImage)
                  setIsOpen(true)
                }}
              />
            </Grid>
            <Grid item>

            </Grid>
            <Grid item>
              <TextField
                required
                fullWidth
                error={errorFields.includes('phone_email')}
                label={`Installer Email`}
                name="phone_email"
                value={formData['phone_email']}
                type="text"
                onChange={(e) => {
                  setFormData({ ...formData, phone_email: e.target.value.trim() });
                  setErrorFields([errorFields.filter((i) => i !== 'phone_email')])
                }}
                onKeyUp={handleSpecialKey}
                variant="filled"
                disabled={submitting}
                inputProps={{
                  type: 'text'
                }}
              />
            </Grid>

            {
              (RECAPTCHA_ENABLED === "true") && (!submitting) && (
                <Grid item>
                  <div className={`recaptcha-wrpper`}>
                    <CaptchaBox
                      recaptcha={recaptcha}
                      setRecaptcha={setRecaptcha}
                      captchaKey={captchaKey}
                      captchaTimestamp={captchaTimestamp}
                    />
                  </div>
                </Grid>
              )
            }

            <Grid item>
              <Button
                type={`submit`}
                variant="contained"
                color="secondary"
                disabled={!formData['iccid'] || !formData['uniqueId'] || !formData['phone_email'] || !formData['iccid_prefix'] || !recaptcha || submitting}
                fullWidth
              >
                {`${(submitting) ? 'Processing' : 'Login'}`}
              </Button>
            </Grid>
          </Grid>
        </form>

        {isOpen && (
          <Lightbox
            mainSrc={currentImage}
            onCloseRequest={() => setIsOpen(false)}
          />
        )}

      </StartPage>
    </>

  );
};

export default InstallerLoginFormTest;
